<ng-container *ngIf="projectUi$ | async as projectUi">

  <div [ngSwitch]="projectUi.uploadStatus">

    <div *ngSwitchCase="ProjectUploadStatus.Waiting">
      <mat-card>
        <p i18n>Waiting for processing</p>
        <mat-progress-bar mode="query"></mat-progress-bar>
      </mat-card>
    </div>
    <div *ngSwitchCase="ProjectUploadStatus.Processing">
      <mat-card>
        <p i18n>Processing project data</p>
        <mat-progress-bar mode="buffer"></mat-progress-bar>
      </mat-card>
    </div>
    <div *ngSwitchCase="ProjectUploadStatus.Error">
      <mat-card>
        <p fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
          <mat-icon [color]="'error'">error</mat-icon>
          <span i18n>Error on process project file</span>
        </p>
        <mat-card-actions>
          <span fxFlex></span>
          <app-help [topic]="'ADD_PROJECT'"></app-help>
          <button mat-raised-button (click)="edit()" i18n>UPLOAD AGAIN</button>
        </mat-card-actions>
      </mat-card>
    </div>

  </div>

</ng-container>
